import { Button } from 'components/ui/button';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import toast from 'react-hot-toast';

const HistoryCardSkeleton = () => {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);

  const handleCreateNewBot = () => {
    if (!isAuthenticated) {
      toast.error("Please login or sign up to create your new bot");
      return;
    }
    // Would normally call setShowForm here
  };

  return (
    <div className="w-full">
      <div className="flex flex-row items-center justify-between">
        <h1 className="text-[28px] font-bold">Your telegram bots</h1>
        <Button
          variant="customSecondary"
          className="text-[14px] text-primary bg-secondary font-normal"
          onClick={handleCreateNewBot}
        >
          Create new bot
        </Button>
      </div>
      <div className="grid grid-cols-2 gap-x-10 gap-y-5 mt-10">
        {Array(2)
          .fill(1)
          .map((_, idx) => {
            return (
              <div
                key={idx}
                className="bg-gray-300 h-[800px] animate-pulse rounded-md"
              />
            );
          })}
      </div>
    </div>
  );
};

export default HistoryCardSkeleton;
